import React from 'react';
import { TwitterPicker } from 'react-color';

const ColorPicker = (props) => {

    const handleChange = (color) => {
        props.onChange(color.hex);
    };

    var white = '#FFFFFF'
    var black = '#000000'
    var orange = '#FF6900'
    var yellow = '#FCB900'
    var darkgreen = '#006400'
    var green = '#00D084'
    var lightblue = '#8ED1FC'
    var darkblue = '#00008B'
    var blue = '#0693E3'
    var gray = '#ABB8C3'
    var brown = '#8B4513'
    var darkbrown = '#4B300B'
    var red = '#C70B1E'
    var lightred = '#F78DA7'
    const colors = [
        white,
        black,
        darkbrown,
        brown,
        gray,
        orange,
        yellow,
        green,
        darkgreen,
        lightblue,
        blue,
        darkblue,
        lightred,
        red,
    ];

    if (!props.visible) {
        return <div />
    }
    return (
        <div style={{ padding: ".5em" }}>
            <div>
                <TwitterPicker onChange={handleChange} colors={colors} triangle={'hide'} styles={{
                    default: {
                        input: {
                            display: 'none',
                        },
                        hash: {
                            display: 'none',
                        },
                        card: {
                            maxWidth: '276px',
                            width: null,
                        }
                    }
                }} />
            </div>
        </div>
    );
}

export default ColorPicker;